import protectedComponent from 'components/helpers/protectedComponent';

import { ADMIN_SETTINGS_VIEW } from 'common/rbac/actions';

export default protectedComponent(() => import('./Admin'), {
  action: ADMIN_SETTINGS_VIEW
});
